const list = {
    buttonList: [
        {
            jurName: "新增",
            actionType: 0,
        },
        // {
        //     jurName: "修改",
        //     actionType: 1,
        // },
        {
            jurName: "扣减押金",
            actionType: 2,
        },
        {
            jurName: "查看明细",
            actionType: 3,
        }
        
    ],
    searchList: [
        {
            showField: "开始时间",
            entityField: "start",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "结束时间",
            entityField: "end",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            isRift: null,
            riftField: null,
            fieldWeight: 120,
        },
        {
            showField: "供应商名称",
            entityField: "smName",
            isShow: 1,
            fieldType: "search",
            searchId: 155784192757760,
            formatterContent: null,
            isRift: null,
            riftField: null,
            setField: "smName,smId",
            fieldWeight: 120,
        },
        {
            defaultValue: "0",
            showField: "状态",
            entityField: "state",
            isShow: 1,
            fieldType: "formatter",
            searchId: null,
            formatterContent: JSON.stringify([
                { 'value': 0, 'key': '未完成' }, 
                { 'value': 1, 'key': '已完成' },
            ]),
            isRift: null,
            riftField: null,
            setField: null,
            fieldWeight: 120,
        }
    ],
    dataList: [
        {
            showField: "供应商名称",
            entityField: "smName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "品牌",
            entityField: "brand",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "付款类型",
            entityField: "payType",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "付款时间",
            entityField: "payTime",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "登记日期",
            entityField: "createTime",
            isShow: 1,
            fieldType: "date",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "登记人",
            entityField: "opmName",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "押金金额",
            entityField: "depositMoney",
            isShow: 1,
            fieldType: "number",
            formatterContent: null,
            fieldWeight: 120,
        },
        {
            showField: "是否存在押金条",
            entityField: "depositSlip",
            isShow: 1,
            fieldType: "formatter",
            formatterContent: [
                { key: 0, value: "否" },
                { key: 1, value: "是" }
            ],
            fieldWeight: 120,
        },
        {
            showField: "押金备注",
            entityField: "remark",
            isShow: 1,
            fieldType: "string",
            formatterContent: null,
            fieldWeight: 120,
        },

    ]
}
export default list
